import React from 'react';
import {Text } from '@chakra-ui/react';

const CountdownTimer = ({time}:{time:number}) => {
  return (
   
      <Text fontSize="sm" color="grey">
        {time > 0 ? `Regenerate code in 0:${time}` : ''}
      </Text>
    
  );
};

export default CountdownTimer;
